module.exports = __webpack_public_path__ + "img/cta-skips.88b72996.png";